<template>
  <!-- 行政区划功能，通用 -->
  <div class="cascader">
    <dictionary :is-multiple="isMultiple" :dictionaries="regionCodeList" v-model="value" :disabled="disabled" @changeData="changed" @clearData="cleared" :place-holder="placeHolder" dict-code="id" dict-name="name">
      <template #prefix>
        <slot name="prefix"></slot>
      </template>
      <template #suffix>
        <slot name="suffix"></slot>
      </template>
    </dictionary>
  </div>

</template>

<script>
import {watch} from "vue";
import Dictionary from "@/components/h5/data/Dictionary.vue";
import administrativeData from "@/assets/js/administrative.json";
export default {
  emits: ["changeData"],
  name: "DicTionary",
  props: {
    modelValue: {
      type: String
    },
    disabled: {default: false},
    placeHolder: {default: "请选择"},
    isMultiple: {default: false}, // 是否开启多选
  },
  components: {
    Dictionary
  },
  data() {
    return {
      regionCodeList: [], // 行政区划
      value: "",
      timeoutInterval: "",
    };
  },
  created() {
    this.init();
    this.value = this.modelValue;
    // 监听
    watch(() => this.modelValue, () => this.value = this.modelValue);
  },
  unmounted() {
    // 如果有任务没执行，就清掉
    if (this.timeoutInterval) {
      clearTimeout(this.timeoutInterval)
    }
  },
  methods: {
    init() {
      this.regionCodeList = administrativeData;
    },
    changed() {
      this.$emit("update:modelValue", this.value);
      this.$emit("changeData", this.value);
    },
    cleared() {
      this.$emit("update:modelValue", "");
      this.$emit("changeData", "");
    }
  }
};
</script>

<style lang="scss" scoped>
.cascader{
  display: inline-flex;
  width: 100%;
}
</style>